export default class RedirectExtension {
	constructor(naja) {
		if (naja.redirectHandler && typeof naja.redirectHandler.addEventListener !== "undefined") {
			try {
				naja.redirectHandler.addEventListener('redirect', (ev) => {
					ev.setHardRedirect(true);
				});
			} catch (e) {
				console.error(e);
			}

		}

		naja.addEventListener('complete', (e) => {
			if (e.response && e.response.openTab) {
				const win = window.open(e.response.openTab, '_blank');
				win.focus();
			}
		});
	}
}